/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { Anchor, AnchorProps } from '@mantine/core'
import { Link, LinkProps } from 'react-router-dom'

export type AnchorLinkProps = AnchorProps & LinkProps

function AnchorLink (props: AnchorLinkProps) {
  const { children, ...others } = props
  return (
    <Anchor
      component={Link}
      inherit
      {...others}
    >
      {children}
    </Anchor>
  )
}

export default AnchorLink
